'use client';
import React, { useEffect, useState } from "react";

interface StatisticProps {
  title: string;
  value:  number;
}

const formatNumber = (num: number): string => {
  if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
  if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";
  return num.toString();
};

const StatisticCard: React.FC<StatisticProps> = ({ title, value }) => {
  const [count, setCount] = useState(0);

   useEffect(() => {
    const target = typeof value === "string" ? parseFloat(value) : value;
    const duration = 3000; // total animation duration in ms
    const frameRate = 30; // update every 30ms
    const totalFrames = duration / frameRate;
    const increment = target / totalFrames;

    let current = 0;
    const counter = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCount(target);
        clearInterval(counter);
      } else {
        setCount(current);
      }
    }, frameRate);

    return () => clearInterval(counter);
  }, [value]);

  return (
    <div className="flex flex-col items-center bg-white w-36 md:w-full lg:w-48 xl:w-56 py-4 md:border-r last:border-r-0">
      <span className="text-gray-600 text-xs md:text-sm xl:text-base text-balance capitalize">{title}</span>
      <span className="text-base lg:text-2xl xl:text-3xl font-bold text-[#002B4E]">
        {formatNumber(Math.floor(count))}
      </span>
    </div>
  );
};

interface StatisticsProps {
  stats: StatisticProps[];
}

const StatisticsGrid: React.FC<StatisticsProps> = ({ stats }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-5 space-y-5 lg:w-[90%] xl:max-w-[71rem] mx-auto mt-14 px-5 md:px-0 ">
      {stats.map((stat, index) => (
        <StatisticCard key={index} title={stat.title} value={stat.value}/>
      ))}
    </div>
  );
};

export default StatisticsGrid;
